export const PC_BREAKPOINT = "781px";
export const PC_HEADER_HEIGHT = "65px";

export enum USER_ROLE {
    ADMIN = "admin",
    MANAGER = "manager",
    ASSISTANT = "assistant",
    NORMAL_USER = "normal"
}